import React from 'react';
import {
  Hero,
  TrustBar,
  Categories,
  FeaturedProducts,
  HowItWorks,
  OurClients,
  BulkQuoteCTA,
  Testimonials,
} from '../components/sections/HomePageSections';

const HomePage = () => (
  <>
    {/* 1. Hero — grid structure PRESERVED */}
    <Hero />

    {/* 2. Trust / Service Benefits */}
    <TrustBar />

    {/* 3. Shop by Category */}
    <Categories />

    {/* 4. Popular Products */}
    <FeaturedProducts />

    {/* 5. How It Works */}
    <HowItWorks />

    {/* 6. Our Clients */}
    <OurClients />

    {/* 7. Why Choose Us */}
    {/* <WhyChooseUs /> */}
  
    {/* 8. Customer Reviews */}
    <Testimonials />

    {/* 9. Bulk / Custom Quote CTA */}
    <BulkQuoteCTA />

    {/* 10. Newsletter */}
    {/* <Newsletter /> */}
  </>
);

export default HomePage;